import { cn } from "@/lib/utils";
import React from "react";
import { ExpertAvatar } from "../Expert/ExpertAvatar";

type UserDisplayNameProps = {
  expert: React.ComponentProps<typeof ExpertAvatar>["expert"];
  className?: string;
  variant?: "default" | "large";
};

export const ExpertDisplayName: React.FC<UserDisplayNameProps> = ({
  expert,
  className,
  variant = "default",
}) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2",
        { "flex-col": variant === "large" },
        className,
      )}
    >
      <ExpertAvatar
        expert={{ ...expert }}
        size={variant === "large" ? "lg" : "sm"}
      />
      <span>{expert.name}</span>
    </div>
  );
};
